import Display, { NewsConfigurationFeature } from "../../../api/model/Display"

export const CUSTOM_SECTION_SCHOOLS: Record<string, string[]> = {
  "kzo-wochenbrief": ["kzo"],
}

export const isCustomSectionEnabled = (
  feature: NewsConfigurationFeature,
  display?: Display | null,
) => {
  if (!display) return false
  const schools = CUSTOM_SECTION_SCHOOLS[feature]
  return (
    !!schools?.includes(display.school) &&
    display.newsConfiguration?.includes(feature) === true
  )
}
